Ext.define('SA.view.ImportReviewStep', {
    alias: 'widget.import-review-step',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-import-review-step',
    hidden: true,

    items: [
        {
            xtype: 'component',
            itemId: 'content',

            tpl: [
                '<table class="sa-import-review-step-general-table">',
                    '<tr>',
                        '<td class="sa-import-review-step-label">Files to Import:</td>',
                        '<td>',
                            '<tpl for="tuples">',
                                '<div class="sa-import-review-step-file-item">',
                                    '{fileName}',
                                    '<span class="sa-import-review-step-geographic-unit">({unit})</span>',
                                '</div>',
                            '</tpl>',
                        '</td>',
                    '</tr>',
                    '<tr><td colspan="2" class="sa-import-review-step-general-table-vertical-spacer"></td></tr>',
                    '<tr>',
                        '<td class="sa-import-review-step-label">Display Name:</td>',
                        '<td>{datasetName:htmlEncode}</td>',
                    '</tr>',
                '</table>',
                '<div class="sa-import-review-step-data-columns-section-label sa-import-review-step-label">Data Columns:</div>',
                '<table class="sa-import-review-step-columns-table">',
                    '<thead>',
                        '<tr>',
                            '<th>Column Name</th>',
                            '<th>Data Type</th>',
                            '<th>Data Format</th>',
                            '<th>Alternate “Friendly” Name</th>',
                        '</tr>',
                    '</thead>',
                    '<tbody>',
                        '<tpl for="columns">',
                            '<tr>',
                                '<td>{headerName}</td>',
                                '<td>{type}</td>',
                                '<td>{format}</td>',
                                '<td>{friendlyName}</td>',
                            '</tr>',
                        '</tpl>',
                    '</tbody>',
                '</table>'
            ]
        }, {
            xtype: 'component',
            cls: 'sa-import-review-step-content-clone-target',
            itemId: 'contentCloneTarget'
        }
    ],

    initComponent() {
        this.callParent();

        this.content = this.down('#content');
        this.contentCloneTarget = this.down('#contentCloneTarget');
    },

    refresh(data) {
        this.content.update(data);
    },

    resizeWithConstraint({maxWidth, maxHeight}) {
        var me = this,
            width = Math.min(maxWidth, getContentWidth() + getPaddingWidth() + Ext.getScrollbarSize().width);

        this.el.setStyle({
            maxHeight: `${maxHeight}px`,
            width: `${width}px`
        });

        function getPaddingWidth() {
            var {paddingLeft, paddingRight} = window.getComputedStyle(me.el.dom);

            return parseFloat(paddingLeft) + parseFloat(paddingRight);
        }

        function getContentWidth() {
            var target = me.contentCloneTarget.el.dom,
                clone = me.content.el.dom.cloneNode(true);

            clone.setAttribute('id', null);
            clone.style.width = null;

            target.innerHTML = '';
            target.appendChild(clone);

            return Ext.fly(clone).getWidth();
        }
    }
});